var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.contentData)?_c('div',[_vm._v(" "+_vm._s(this.startMeeting())+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }